import { render } from 'preact';
import { getServiceContentById } from '@/api';
import { validateNotExcludedItem } from '@/helpers/validate';
import { log } from '@/utils';

import { CSS_PATH, WIDGET_MOUNT_ID } from '../constants';
import { createScopedStylesheet } from '../helpers/dom';
import {
  createDialogShadowPortal,
  createWidgetShadowRoot,
} from '../helpers/shadow-root';
import { PdpRootWidget } from './pdp-root-widget';

export async function mountPdpWidget() {
  try {
    const [styles, serviceContentById] = await Promise.all([
      createScopedStylesheet(CSS_PATH),
      getServiceContentById(),
    ]);

    if (!serviceContentById || !styles) {
      log.warn('Missing required widget data. Skipping PDP widget.');
      return;
    }

    const productExclusionCheck = validateNotExcludedItem(
      WIDGET_MOUNT_ID,
      'data-product-title',
    );
    if (!productExclusionCheck.ok) return log.warn(productExclusionCheck.msg);

    const root = createWidgetShadowRoot(WIDGET_MOUNT_ID, styles);
    if (!root) return;

    createDialogShadowPortal(styles);

    render(<PdpRootWidget serviceContentById={serviceContentById} />, root);
  } catch (err) {
    log.error('PDP widget failed to mount:', { err });
  }
}
